import { Helper } from "../core/util/helper.js";
import { General } from "../../siteManagement/general.js";
import { StringKeyDictionary } from "../commonInterfaces.js";

export const createService = () => {
    return (() => {
        let currentIndex = -1;

        return {
            updateSearchUrl: (filterValues: StringKeyDictionary<any>, quickSearch: string, empty: boolean) => {
                const withQuickSearch = Helper.hasValue(quickSearch) && quickSearch !== "";
                //get current query string parameters
                const params = Helper.getQueryStringParameters();
                //remove _start and _end params
                for (let key in params) {
                    if (Helper.endsWith(key, "_start") || Helper.endsWith(key, "_end")) {
                        delete params[key];
                    }
                }

                if (withQuickSearch) {
                    params["quick"] = quickSearch;
                } else {
                    delete params["quick"];
                }

                //go through all query filter values
                for (let key in filterValues) {
                    //if the value is defined and not empty...
                    if ((!withQuickSearch || Helper.useMobileGui()) && Helper.hasValue(filterValues[key]) && filterValues[key] !== "") {
                        //...update/add the key and value
                        if (filterValues[key] instanceof Date) {
                            params[key] = Helper.dates.getISODateString(filterValues[key]);
                        } else {
                            params[key] = filterValues[key];
                        }
                    } else {
                        //...otherwise, remove the key
                        delete params[key];
                    }
                }



                const newQueryString = $.param(params);
                let url = window.location.href;
                if (window.location.href.indexOf("?") !== -1) {
                    url = window.location.href.substring(0, window.location.href.indexOf("?") + 1) + newQueryString
                } else {
                    url += "?" + newQueryString;
                }

                if (url[url.length - 1] === "?") {
                    url = url.substr(0, url.length - 1);
                }

                if (window.location.href !== url) {
                    currentIndex++;
                    const state: DynamicSearchHistoryState = {
                        index: currentIndex,
                        empty: empty
                    };
                    //history.pushState(state, null, url);
                    //General.Functions.HistoryState.pushState(url);
                    General.Functions.HistoryState.pushState(url);
                }

                return currentIndex;
            },
            convertColor: (delphiColor: number) => {
                if (!Helper.hasValue(delphiColor) || delphiColor == 0) {
                    return "transparent";
                } else if (delphiColor == 1) {
                    return "#000000";
                } else {
                    const r = (delphiColor & 0x000000FF) >> 0;
                    const g = (delphiColor & 0x0000FF00) >> 8;
                    const b = (delphiColor & 0x00FF0000) >> 16;

                    let rh = r.toString(16);
                    rh = rh.length === 1 ? "0" + rh : rh;
                    let gh = g.toString(16);
                    gh = gh.length === 1 ? "0" + gh : gh;
                    let bh = b.toString(16);
                    bh = bh.length === 1 ? "0" + bh : bh;

                    const hexColor = "#" + rh + gh + bh;

                    return hexColor;
                }
            },
            initPageHistoryState: () => {
                const state = history.state as DynamicSearchHistoryState;
                if (!Helper.hasValue(state) || !Helper.hasValue(state.index)) {
                    currentIndex = 0;
                    //const state: DynamicSearchHistoryState = {
                    //    index: currentIndex,
                    //    empty: false
                    //};
                    //history.replaceState(state, null, location.href);
                    //General.Functions.HistoryState.acquireState();
                    General.Functions.HistoryState.acquireState();
                } else {
                    currentIndex = state.index;
                }

                return currentIndex;
            }
        };
    })();
}


export interface DynamicSearchHistoryState {
    index: number;
    empty: boolean;
}